import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import {
  getConsolidationDetailRoutePath,
  getProductRoute,
  matchAnyOnboardingRoute,
  useMobileOrTableWindowResize
} from '@futrli/shared-services';

import { AppNavbarSecondaryContent } from './app-navbar-secondary-content';

interface AppNavbarSecondaryProps {
  displayGlobalNav: boolean;
}

export const AppNavbarSecondary = ({ displayGlobalNav }: AppNavbarSecondaryProps) => {
  const isMobileOrTableWS = useMobileOrTableWindowResize();

  const { pathname } = useLocation();
  const isOnboardingRoute = matchAnyOnboardingRoute(pathname);

  // Secondary navbar shouldn't be displayed during onboarding process
  if (isMobileOrTableWS || isOnboardingRoute) {
    return null;
  }

  return (
    <Routes>
      <Route
        path={`${getProductRoute()}/*`}
        element={<AppNavbarSecondaryContent displayGlobalNav={displayGlobalNav} />}
      />
      <Route
        path={`${getConsolidationDetailRoutePath()}/*`}
        element={<AppNavbarSecondaryContent displayGlobalNav={displayGlobalNav} />}
      />
    </Routes>
  );
};
